import React from "react";
import { useSelector } from "react-redux";
import checkIcon from '../../../../../assests/dashboard/friends/check.png'
import classes from './ConfirmShareProjectPopup.module.css'
import useShareTypes from "../../../../../hooks/useShareTypes";
import { ObjectTypeEnum } from "../../../../../models/ObjectTypeEnum";
import External from "./External";
import SuccessProjectPopup from "../../../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";

const ConfirmShareProjectPopup = ({ title, close, text, type, optionsSelect, changePosts, confirmFunc, dataPost }) => {

    const texts = useSelector(state => state.translate.texts);

    const selectedList = useShareTypes()
    function BtnOkFunc() {
        close()
        changePosts && changePosts()
    }

    return (
        <SuccessProjectPopup title={title ? title : texts.shareProject} color="#CCF0F0" close={() => close()} myHeight={Number(optionsSelect) === ObjectTypeEnum.External ? '350px' : '251px'} myWidth={'554px'}>
            <div className={classes.EndPopupContainer}>
                <div className={classes.SuccessIconAndText}>
                    {!confirmFunc && <img src={checkIcon} className={classes.Icon} alt='CheckIcon' />}
                    <p className={classes.TitleSmallPost}>{text}</p>
                </div>
                {type === "successPublishPost" && <p className={classes.NameSharedGroup}>{texts.to}{selectedList()[optionsSelect]}</p>}
                {Number(optionsSelect) === ObjectTypeEnum.External && <div className={classes.External}><External dataPost={dataPost} /></div>}
                {confirmFunc ?
                    <div className={classes.ConfirmBtnContainer}>
                        <button onClick={() => close()} className={classes.BtnCancel}>{texts.cancel}</button>
                        <button onClick={confirmFunc} className={classes.BtnConfirm}>{texts.ok}</button>
                    </div> :
                    <div className={classes.ConfirmBtnContainer}>
                        <div></div>
                        <button onClick={BtnOkFunc} className={classes.BtnConfirm}>{texts.ok}</button>
                    </div>
                }
            </div>
        </SuccessProjectPopup>
    )
}

export default ConfirmShareProjectPopup;